import type { AggregatedNoteDto } from "../../../services/vorgangNoteService";
import { notizenAmVorgang } from "./erstesTodoNotizen";

/**
 * Der Vorgang als ERSTE To-do-Karte (PO 13./14.09.2026: „vorgang mit todos wo
 * notizen und mails nicht zu todo dann bitte rendern als vorgang gleich erstes
 * todo").
 *
 * ══ WAS HIER REPARIERT WIRD ════════════════════════════════════════════════
 * V4 zeichnet den Vorgangsstrom nur, solange es KEINE To-dos gibt
 * (`{!hatTodos && <ArbeitsstrangV4 …>}`), und die Notizfläche filtert auf ihren
 * Strang. Hat ein Vorgang To-dos UND eigene Einträge (`todoId == null`), stehen
 * diese Mails, Anrufe, Dokumente und Notizen auf der ganzen Seite nirgends —
 * nicht gelöscht, aber unerreichbar.
 *
 * Das ist NICHT der Sonderfall: `planeTodoAnlage` — die Übernahme „der Vorgang
 * wird To-do 1" — gibt es erst seit V4. In der Altansicht V2 (bis 14.09.2026
 * die Standardansicht, am 20.09.2026 entfernt) entstanden To-dos ohne jede
 * Übernahme. Jeder dort aufgeteilte Vorgang mit eigenem Schriftwechsel ist
 * betroffen — der Bestand bleibt, auch wenn die Ansicht weg ist.
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * ══ ANZEIGEN, NICHT UMHÄNGEN ═══════════════════════════════════════════════
 * Diese Einträge werden NICHT still an ein neu erfundenes erstes To-do
 * gehängt. Das Repo hält die Linie ausdrücklich (`todoDarstellung.ts`:
 * „Umbenannt oder gelöscht wird NICHTS: das wäre eine stille Datenänderung").
 * Der Vorgang bleibt der Vorgang — er bekommt nur die GESTALT einer
 * To-do-Karte, weil er an dieser Stelle dasselbe ist: ein Arbeitsstrang.
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * Reine Ableitung, bewusst ohne React: die Frage „bekommt der Vorgang eine
 * eigene Karte über seinen To-dos" gehört an einen Ort mit einem Test, nicht
 * als verschachtelte Bedingung in den Render-Baum.
 */

/**
 * Erscheint der Vorgang als erste To-do-Karte?
 *
 * Nur, wenn er BEIDES hat: To-dos (sonst trägt er seinen Strom selbst, wie
 * bisher) und etwas Eigenes zu zeigen. Ohne die zweite Bedingung wüchse jedem
 * gewöhnlichen Vorgang eine leere Karte über seine To-dos.
 *
 * Gezählt werden Ereignisse (`eigeneEintraege` — die Seite hat sie schon
 * gefiltert) UND Notizen. Die Notizen stecken NICHT in den Einträgen:
 * `baueVerlauf` liefert seit dem 08.09.2026 keine mehr. Welche Notiz dem
 * Vorgang gehört, weiß `notizenAmVorgang` — dort steht auch, warum `todoId`
 * bei `source === "todo"` etwas anderes bedeutet als bei `"vorgang"`.
 */
export function zeigeVorgangsStrang(a: {
    hatTodos: boolean;
    eigeneEintraege: ReadonlyArray<unknown>;
    notizen: AggregatedNoteDto[];
}): boolean {
    if (!a.hatTodos) return false;
    return a.eigeneEintraege.length > 0 || notizenAmVorgang(a.notizen).length > 0;
}

/*
 * ══ HIER STAND `betreffTraeger` (13.–18.09.2026) ═══════════════════════════
 * Die Weiche entschied, WER den Vorgangsbetreff zeigt — Kopf, Vorgangskarte
 * oder erstes To-do —, damit er genau einmal auf der Seite steht.
 *
 * Am 18.09.2026 hat der PO das umgedreht: „Vorgang mit To-dos hat Überschrift
 * und Untertitel — erstes To-do hat dann dieselbe Überschrift und den Verlauf
 * des bisherigen Vorgangs." Der Betreff steht seitdem IMMER im Kopf
 * (`VorgangKopfV4`); dass das erste To-do denselben Text trägt, ist keine
 * Dopplung aus Versehen, sondern die Aussage: dieses To-do ist aus dem Vorgang
 * entstanden.
 *
 * `todoTraegtVorgangsBetreff` bleibt bestehen — die To-do-Darstellung braucht
 * den Vergleich weiterhin.
 * ═══════════════════════════════════════════════════════════════════════════
 */
